import { BordOneToneIcon } from 'components/NudosComponents';
import { BordTooltip } from 'bord-design-system';

import './QuoteProductStatusCountSummary.scss';

interface IQuoteProductStatusCountSummary {
  rejected?: number;
  approved?: number;
  expired?: number;
  expiredTooltipMessage?: string;
}

/**
 * Resumen con tres contadores de herramientas de una cotización: el primero
 * (configurable vía `expiredTooltipMessage`) representa las herramientas sin
 * respuesta del cliente — "vencidas" cuando la cotización ya expiró o
 * "pendientes" mientras sigue activa —, seguido de las aprobadas y las canceladas.
 */
export const QuoteProductStatusCountSummary = ({
  rejected = 0,
  approved = 0,
  expired = 0,
  expiredTooltipMessage = 'Herramientas vencidas'
}: IQuoteProductStatusCountSummary) => {
  return (
    <div className="quoteProductStatusCountSummary">
      <BordTooltip customClassNameMessageContainer="toolsStatusTooltip" message={expiredTooltipMessage} position="top">
        <div className="item">
          <BordOneToneIcon className="quoteProductStatusCountSummaryIcon" variant="clock" customWidth="1.2rem" />
          {expired}
        </div>
      </BordTooltip>
      <div className="divider" />

      <BordTooltip customClassNameMessageContainer="toolsStatusTooltip" message="Herramientas aprobadas" position="top">
        <div className="item">
          <BordOneToneIcon className="quoteProductStatusCountSummaryIcon" variant="checkCircle" customWidth="1.2rem" />
          {approved}
        </div>
      </BordTooltip>
      <div className="divider" />
      <BordTooltip
        customClassNameMessageContainer="toolsStatusTooltip"
        message="Herramientas rechazadas"
        position="top"
      >
        <div className="item">
          <BordOneToneIcon className="quoteProductStatusCountSummaryIcon" variant="xCircle" customWidth="1.2rem" />
          {rejected}
        </div>
      </BordTooltip>
    </div>
  );
};
